import { tap } from 'rxjs';
import { GetAdditionalRoutineArgs } from '../../types';

export const getScrollHighlightedIntoViewRoutine = ({
  navigator$,
}: GetAdditionalRoutineArgs) =>
  navigator$.pipe(
    tap(({ rootLayoutBox, container, tree }) => {
      if (!tree.keyboardSelectedNodeId) {
        return;
      }
      const highlightedItem = rootLayoutBox.children.find(
        layoutBox => layoutBox.node.isHighlighted
      );
      if (!container || !highlightedItem) {
        return;
      }
      if (highlightedItem.top < rootLayoutBox.scrollTop) {
        container.scrollTop = highlightedItem.top;
      } else if (
        highlightedItem.bottom >
        rootLayoutBox.scrollTop + rootLayoutBox.height
      ) {
        container.scrollTop = highlightedItem.bottom - rootLayoutBox.height;
      }
    })
  );
